import ProjectCreateForm from "./ProjectCreateForm";
import NamespaceCreateForm from "./NamespaceCreateForm";
import SectionCreateForm from "./SectionCreateForm";
import SheetSettingForm from "./SheetSettingForm";
import FilterMenu from "./FilterMenu";
import RowControlModal from "./RowControlModal";

export const ModalRegistry = {
  // PROJECT_CREATE: ProjectCreateForm,
  // NAMESPACE_CREATE: NamespaceCreateForm,
  // SECTION_CREATE: SectionCreateForm,
  FILTER_MENU: FilterMenu,
  ROW_CONTROL: RowControlModal,
  SHEET_SETTING: SheetSettingForm
};
